export function toStringValue(v: unknown): string | undefined {
  if (typeof v === 'string') return v.trim() || undefined;
  if (typeof v === 'number') return String(v);
  return undefined;
}

export function firstStringValue(...values: unknown[]): string | undefined {
  for (const v of values) {
    const s = toStringValue(v);
    if (s) return s;
  }
  return undefined;
}

export function firstNonEmptyString(...values: unknown[]): string | undefined {
  for (const v of values) {
    if (typeof v === 'string' && v.trim() !== '') return v;
  }
  return undefined;
}
